import { z } from "zod"

export enum CouponType {
  PERCENT = "PERCENT",
  DIRECT = "DIRECT",
}

export const CouponDtoSchema = z
  .object({
    value: z.number(),
    type: z.enum(CouponType),
    duration: z.number().nullable(),
    createdAt: z.iso.datetime(),
  })
  .meta({ id: "CouponDtoSchema" })

export const CouponInputSchema = z
  .object({
    durationInMonths: z.number().nullable(),
    type: z.enum(CouponType),
    value: z.number(),
  })
  .meta({ id: "CouponInputSchema" })

export type CouponDto = z.infer<typeof CouponDtoSchema>
export type CouponInput = z.infer<typeof CouponInputSchema>
